import React from "react";
import Banner from "../components/rsvps/banner";
import RsvpForm from "../components/rsvps/rsvp-form";
import RsvpFooter from "../components/rsvps/rsvp-footer";

function RsvpPage() {
  return (
    <>
      <Banner />
      <RsvpForm />
      <RsvpFooter />
    </>
  );
}

export default RsvpPage;
